<div class="menuUser">
    <ng-container *ngIf="usuarioConectado; else usuarioNoConectado">
      <!-- href="<?=DC_Rutas::getRuta(ID_PAGINA_MI_CUENTA)?>" -->
        <!-- lang admin_miCuenta -->
     <a class="btn btn-n1" href="#" [title]="usuarioConectado.nombre">
 
         <span>Mi cuenta</span>
     </a>
     <a class="btn btn-n1" (click)="logout()" title="">
         <i class="icon-24 icon-ibm-logout"></i>
         <!-- lang dc_salir -->
         <span>Salir</span>
     </a>
 
    </ng-container>
    <ng-template #usuarioNoConectado>
        <!-- href="<?=DC_Rutas::getRuta(ID_PAGINA_LOGIN)?>" -->
        <!-- lang dc_accede -->
    <a class="btn btn-secondary" (click)="accederAreaCliente()" [title]="'Accede'">
        <span>Mi reserva</span>
     </a>
 
     <!--href="<?=DC_Rutas::getRuta(ID_PAGINA_REGISTRO)?>" -->
     <!-- lang dc_registrate -->
     <a href="#" title="'Registrarse'" *ngIf="ADMIN_REGISTRO_FRONT">
         <i class="mdi mdi-account-plus"></i>
          <!-- lang dc_registrate -->
         <span class="hidden-xs">Registrarse</span>
     </a>
    </ng-template>
 
 
 
 </div>
 
<neo-proximamente-dlg [tituloDialog]="'proximamente_dlg_tit' | transloco"
    [descripcionDialog]="'proximamente_dlg_txt' | transloco">
</neo-proximamente-dlg>